import { apiClient } from './client';

export async function getCustomerPortalMe() {
  const { data } = await apiClient.get('/api/customer-portal/me');
  return data;
}

export async function getCustomerPortalCustomers() {
  const { data } = await apiClient.get('/api/customer-portal/customers');
  return data;
}

export async function getCustomerPortalCustomer(customerId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}`);
  return data.data;
}

export async function getCustomerPortalDashboardSummary(customerId) {
  const { data } = await apiClient.get(
    `/api/customer-portal/customers/${customerId}/dashboard/summary`,
  );
  return data.data;
}

export async function getCustomerPortalTenants(customerId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/tenants`);
  return data;
}

export async function getCustomerPortalBilling(customerId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/billing`);
  return data.data;
}

export async function createCustomerPortalStripeSession(customerId) {
  const { data } = await apiClient.post(`/api/customer-portal/customers/${customerId}/billing/stripe-portal-session`);
  return data.data;
}

export async function getCustomerPortalSupportTickets(customerId, params = {}) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/support/tickets`, {
    params: { per_page: 50, ...params },
  });
  return data;
}

export async function getCustomerPortalSupportTicketFormSchema(customerId, params = {}) {
  const { data } = await apiClient.get(
    `/api/customer-portal/customers/${customerId}/support/ticket-form-schema`,
    { params },
  );
  return data.data;
}

export async function createCustomerPortalSupportTicket(customerId, payload) {
  const { data } = await apiClient.post(`/api/customer-portal/customers/${customerId}/support/tickets`, payload);
  return data.data;
}

export async function getCustomerPortalSupportTicket(ticketId) {
  const { data } = await apiClient.get(`/api/customer-portal/support/tickets/${ticketId}`);
  return data.data;
}

export async function createCustomerPortalSupportMessage(ticketId, payload) {
  const { data } = await apiClient.post(`/api/customer-portal/support/tickets/${ticketId}/messages`, payload);
  return data.data;
}

export async function markCustomerPortalSupportViewed(ticketId) {
  await apiClient.post(`/api/customer-portal/support/tickets/${ticketId}/mark-viewed`);
}

export async function getCustomerPortalSupportSla(ticketId) {
  const { data } = await apiClient.get(`/api/customer-portal/support/tickets/${ticketId}/sla`);
  return data.data;
}

export async function uploadCustomerPortalSupportAttachment(customerId, ticketId, formData) {
  const { data } = await apiClient.post(
    `/api/customer-portal/customers/${customerId}/support/tickets/${ticketId}/attachments`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return data.attachment || data.data;
}

export async function downloadCustomerPortalSupportAttachment(customerId, ticketId, attachmentId) {
  const response = await apiClient.get(
    `/api/customer-portal/customers/${customerId}/support/tickets/${ticketId}/attachments/${attachmentId}/download`,
    { responseType: 'blob' },
  );
  return response.data;
}

export async function getCustomerPortalSupportInvolvedCandidates(ticketId, params = {}) {
  const { data } = await apiClient.get(
    `/api/customer-portal/support/tickets/${ticketId}/involved-users/candidates`,
    { params },
  );
  return data.data || [];
}

export async function addCustomerPortalSupportInvolvedUser(ticketId, userId) {
  const { data } = await apiClient.post(
    `/api/customer-portal/support/tickets/${ticketId}/involved-users`,
    { user_id: userId },
  );
  return data.data;
}
